/*
 * JESA paella set builder: ready-made sets by number of diners (<lotes-comensales>)
 * and the guided step-by-step builder (<lotes-configurador>).
 * Compatibility rules come from lotes-jesa-reglas.js (copied from the classic set builder)
 * and behave like the classic builder in assets/configurador-jesa.js.
 */
(function () {
  if (window.LotesJesa) return;
  const R = window.JESA_REGLAS;
  const MAX_PAELLAS = 3;

  // ---------- catalogue ----------------------------------------------------
  let catalogue = null;
  function loadCatalogue() {
    if (catalogue) return catalogue;
    const el = document.querySelector('[data-lotes-catalogo]');
    const raw = el ? JSON.parse(el.textContent) : [];
    const aros = { 'plano-30': 2, 'plano-40': 3, 'plano-50': 3, 'plano-60': 4, 'plano-70': 4 };
    raw.forEach((i) => {
      i.cm = String(i.key).trim().split(/[ -]/)[0];
      if (i.kind === 'paella') {
        i.cm = i.key.trim().split(' ')[0];
        i.raciones = (i.key.match(/(\d+)\s*raciones/) || [])[1] || '';
        i.name = `Paella ${i.group} ${i.cm} cm`;
      } else if (i.kind === 'paellero') {
        if (i.group === 'plano') {
          i.cm = i.key.split('-')[1];
          i.name = `Paellero plano ${aros[i.key]} aros · ${i.cm} cm`;
        } else {
          const [n, , cm] = i.key.split('-');
          i.cm = cm;
          i.name = `Paellero ${n} ${n === '1' ? 'aro' : 'aros'} · ${cm} cm`;
        }
      } else if (i.kind === 'sarten') {
        i.cm = i.key;
        i.name = `Sartén honda ${i.key} cm`;
        i.sub = (i.variant.split(' - ')[1] || '').trim();
      } else {
        const names = {
          'asador-65': 'Asador 65 cm', 'asador-52': 'Asador 52 cm', 'asador-42': 'Asador 42 cm', 'plancha-46': 'Plancha grill 46 cm',
          paella: 'Paravientos para paella', 'paravientos-2-aros': 'Paravientos paellero 30 – 50 cm', 'paravientos-3-aros': 'Paravientos paellero 50 – 70 cm',
        };
        i.name = names[i.key] || (i.variant ? `${i.product} · ${i.variant}` : i.product);
      }
    });
    const by = (kind, group) => raw.filter((i) => i.kind === kind && (group === undefined || i.group === group));
    catalogue = {
      all: raw,
      paellas: { esmaltada: by('paella', 'esmaltada'), pulida: by('paella', 'pulida') },
      paelleros: by('paellero'),
      soportes: by('soporte'),
      reguladores: by('regulador'),
      paravientos: by('paravientos'),
      asadores: by('asador'),
      sartenes: by('sarten'),
      byId: (id) => raw.find((i) => String(i.id) === String(id)),
    };
    return catalogue;
  }

  // ---------- rules (same outcomes as the classic builder) -------------------
  const isPlano = (p) => p && p.group === 'plano';
  const planoNum = (p) => p.key.split('-')[1];
  function paelleroFits(p, paellas) {
    return paellas.every((pa) =>
      isPlano(p)
        ? (R.reglasPlanosPorMedida[planoNum(p)] || []).includes(pa.cm)
        : ((R.reglasJesaInversas[pa.key] || {}).paellerosValidos || []).includes(p.key)
    );
  }
  const byRule = (list, rule, p) => (p ? list.filter((x) => (rule[p.key] || []).includes(x.key)) : []);
  const soportesFor = (C, p) => byRule(C.soportes, R.reglasSoportes, p);
  const reguladoresFor = (C, p) => byRule(C.reguladores, R.reglasReguladores, p);
  function paravientosFor(C, p, paellas) {
    return C.paravientos.filter((v) =>
      v.key === 'paella' ? paellas.length > 0 : !!p && (R.reglasParavientosPaellero[p.key] || []).includes(v.key)
    );
  }
  // The classic builder ends up checking grills against the paellero only, so we do the same
  function asadoresFor(C, p) {
    if (!p) return [];
    return C.asadores.filter((a) =>
      isPlano(p) ? (R.reglasAsadoresPlanos[a.key] || []).includes(planoNum(p)) : (R.reglasAsadores[a.key] || []).includes(p.key)
    );
  }
  function sartenesFor(C, p) {
    if (!p) return [];
    return C.sartenes.filter((s) =>
      isPlano(p) ? (R.reglasPlanosPorMedida[planoNum(p)] || []).includes(s.cm) : (R.reglasSartenHonda[s.cm] || []).includes(p.key)
    );
  }
  // Suggestion only: the burner closest to ~80% of the (largest) paella diameter
  function recommendedPaellero(list, paellas) {
    if (!paellas.length || !list.length) return null;
    const target = Math.max(...paellas.map((p) => +p.cm)) * 0.8;
    return list.filter((p) => p.available).sort((a, b) => Math.abs(a.cm - target) - Math.abs(b.cm - target) || a.price - b.price)[0] || null;
  }

  // ---------- helpers -------------------------------------------------------
  const money = (cents) => (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  const total = (items) => items.reduce((s, i) => s + i.price, 0);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function shippingHTML(t, threshold) {
    if (!threshold) return '';
    if (t >= threshold * 100) return '<span class="lotes-ok">✓ Envío gratis incluido</span>';
    return `Te faltan <b>${money(threshold * 100 - t)}</b> para el envío gratis`;
  }
  function cardHTML(item, o = {}) {
    const off = !item.available;
    return `<button type="button" class="lotes-card${o.selected ? ' is-selected' : ''}${off ? ' is-off' : ''}" data-id="${item.id}" ${off ? 'disabled' : ''} aria-pressed="${!!o.selected}">
      ${o.badge ? `<span class="lotes-badge lotes-card__badge">${esc(o.badge)}</span>` : ''}
      <span class="lotes-card__check${o.multi ? ' is-multi' : ''}" aria-hidden="true"></span>
      <img src="${item.img}" alt="" loading="lazy" width="400" height="400">
      <span class="lotes-card__title">${esc(o.title || item.name)}</span>
      ${o.sub || item.sub ? `<span class="lotes-card__sub">${esc(o.sub || item.sub)}</span>` : ''}
      <span class="lotes-card__price">${off ? 'Agotado' : money(item.price)}</span>
    </button>`;
  }
  async function addToCart(items, button) {
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Añadiendo lote...';
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map((i) => ({ id: i.id, quantity: 1 })) }),
      });
      if (!res.ok) throw new Error('cart');
      window.location.href = window.Shopify.routes.root + 'cart';
    } catch (e) {
      button.disabled = false;
      button.textContent = label;
      return false;
    }
    return true;
  }

  // ---------- guided builder ------------------------------------------------
  const STEP_NAMES = ['Paella', 'Paellero', 'Soporte o patas', 'Regulador y goma'];
  class LotesConfigurador extends HTMLElement {
    connectedCallback() {
      this.C = loadCatalogue();
      this.threshold = Number(this.dataset.freeShipping || 0);
      this.S = { finish: 'esmaltada', gama: 'std', paellas: [], noPaella: false, paellero: null, soporte: null, regulador: null, extras: new Set(), open: 0, showAll: false, msg: '' };
      this.steps = this.querySelector('[data-steps]');
      this.summary = this.querySelector('[data-summary]');
      this.addEventListener('click', (e) => this.onClick(e));
      this.render();
      // On phones the summary is a bottom bar: only show it while the builder is on screen
      this.observer = new IntersectionObserver(([entry]) => this.summary.classList.toggle('is-visible', entry.isIntersecting));
      this.observer.observe(this.steps);
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
    load(state) {
      const S = this.S;
      S.finish = state.finish || 'esmaltada';
      S.paellas = (state.paellas || []).map((id) => this.C.byId(id)).filter(Boolean);
      S.noPaella = false;
      S.paellero = this.C.byId(state.paellero) || null;
      S.gama = isPlano(S.paellero) ? 'plano' : 'std';
      S.soporte = this.C.byId(state.soporte) || null;
      S.regulador = this.C.byId(state.regulador) || null;
      S.extras = new Set((state.extras || []).map(String));
      this.nextOpen();
      this.render();
    }
    prune() {
      const S = this.S, C = this.C;
      if (S.paellero && !paelleroFits(S.paellero, S.paellas)) S.paellero = null;
      if (S.soporte && !soportesFor(C, S.paellero).includes(S.soporte)) S.soporte = null;
      if (S.regulador && !reguladoresFor(C, S.paellero).includes(S.regulador)) S.regulador = null;
      const ok = new Set([...paravientosFor(C, S.paellero, S.paellas), ...asadoresFor(C, S.paellero), ...sartenesFor(C, S.paellero)].map((x) => String(x.id)));
      for (const id of [...S.extras]) if (!ok.has(id)) S.extras.delete(id);
    }
    extrasItems() {
      return [...this.C.paravientos, ...this.C.asadores, ...this.C.sartenes].filter((x) => this.S.extras.has(String(x.id)));
    }
    items() {
      const S = this.S;
      return [...S.paellas, S.paellero, S.soporte, S.regulador].filter(Boolean).concat(this.extrasItems());
    }
    hasSarten() {
      return this.extrasItems().some((x) => x.kind === 'sarten');
    }
    canAdd() {
      return (this.S.paellas.length > 0 || this.hasSarten()) && !!this.S.paellero;
    }
    nextOpen() {
      this.prune();
      const S = this.S;
      S.showAll = false;
      if (!S.paellas.length && !S.noPaella) S.open = 0;
      else if (!S.paellero) S.open = 1;
      else if (!S.soporte && soportesFor(this.C, S.paellero).length) S.open = 2;
      else if (!S.regulador && reguladoresFor(this.C, S.paellero).length) S.open = 3;
      else S.open = 4;
    }
    seg(options, current, act) {
      return `<span class="lotes-seg">${options.map(([v, l]) => `<button type="button" data-act="${act}" data-v="${v}" class="${v === current ? 'is-on' : ''}">${l}</button>`).join('')}</span>`;
    }
    grid(list, o = {}) {
      const S = this.S;
      const limit = o.limit || 10;
      const shown = S.showAll || list.length <= limit ? list : list.slice(0, limit);
      const sel = (x) => (o.isSel ? o.isSel(x) : o.multi ? S.extras.has(String(x.id)) : o.current === x);
      return `<div class="lotes-grid">${shown.map((x) => cardHTML(x, { selected: sel(x), multi: o.multi, title: o.title && o.title(x), sub: o.sub && o.sub(x), badge: o.rec === x ? 'Recomendado' : '' })).join('')}</div>
        ${shown.length < list.length ? `<button type="button" class="lotes-link" data-act="all">Ver ${list.length - shown.length} más</button>` : ''}`;
    }
    help(title, html) {
      return `<details class="lotes-help"><summary>💡 ${title}</summary><div>${html}</div></details>`;
    }
    render() {
      this.prune();
      const S = this.S, C = this.C;
      const val = (x) => (x ? `${esc(x.name)} · ${money(x.price)}` : '');
      const extraNames = (kinds) => this.extrasItems().filter((x) => kinds.includes(x.kind)).map((x) => esc(x.name)).join(', ');
      const steps = [
        {
          t: 'Paella', ready: true,
          val: S.paellas.length ? S.paellas.map((p) => `${p.group === 'esmaltada' ? 'Esmaltada' : 'Pulida'} ${p.cm} cm (${p.raciones} raciones)`).join(', ') + ` · ${money(total(S.paellas))}` : S.noPaella ? 'Sin paella (solo sartén honda)' : '',
          body: () => `<div class="lotes-row">${this.seg([['esmaltada', 'Esmaltada · sin mantenimiento'], ['pulida', 'Pulida · tradicional']], S.finish, 'finish')}<span class="lotes-muted">Puedes elegir hasta ${MAX_PAELLAS} tamaños</span></div>
            ${this.help('¿Esmaltada o pulida? ¿Qué tamaño?', '<p><b>Esmaltada:</b> cómoda, tiene protección y no necesita mantenimiento especial ni aceite tras lavarse.</p><p><b>Pulida:</b> clásica, gran conducción, pero exige secarla y untarla con una fina capa de aceite al guardarla para evitar óxido.</p><p><b>Regla de oro estilo valenciano:</b> si buscas arroz de capa fina para un socarrat perfecto, reduce las raciones del catálogo a la mitad (ej.: 14 raciones, ideal para 6 o 7 personas).</p>')}
            ${this.grid(C.paellas[S.finish], { limit: 16, isSel: (x) => S.paellas.includes(x), multi: true, title: (x) => `${x.cm} cm`, sub: (x) => `${x.raciones} raciones` })}
            ${S.msg ? `<p class="lotes-msg">${S.msg}</p>` : ''}
            <div class="lotes-row lotes-row--end">${S.paellas.length ? `<button type="button" class="lotes-btn" data-act="continue">Continuar con ${S.paellas.length} paella${S.paellas.length > 1 ? 's' : ''} →</button>` : `<button type="button" class="lotes-link" data-act="nopaella">No necesito paella, solo una sartén honda</button>`}</div>`,
        },
        {
          t: 'Paellero de gas', ready: S.paellas.length > 0 || S.noPaella, lock: 'Elige primero tu paella', val: val(S.paellero),
          body: () => {
            const pool = C.paelleros.filter((p) => (S.gama === 'plano') === isPlano(p)).filter((p) => paelleroFits(p, S.paellas));
            const rec = recommendedPaellero(pool, S.paellas);
            const label = S.paellas.length ? `${pool.length} compatibles con ${S.paellas.map((p) => p.cm + ' cm').join(' y ')}` : `${pool.length} modelos`;
            return `<div class="lotes-row">${this.seg([['std', 'Estándar'], ['plano', 'Plano · alta gama']], S.gama, 'gama')}<span class="lotes-muted">${label}</span></div>
              ${this.help('¿Estándar o plano?', '<p><b>Llama más repartida:</b> el diseño de los orificios distribuye el fuego de manera uniforme por la base, evitando zonas frías.</p><p><b>Control de gas más sensible:</b> los mandos profesionales permiten una regulación del fuego milimétrica.</p><p><b>Seguridad en el mínimo:</b> cuenta con un tope de seguridad para que nunca cierres el gas por completo por error cuando bajas la potencia al mínimo.</p>')}
              ${pool.length ? this.grid(pool, { current: S.paellero, rec, title: (x) => x.name.replace(/^Paellero /, '') }) : '<div class="lotes-empty">Ningún paellero de esta gama encaja con tu paella. Prueba la otra gama.</div>'}`;
          },
        },
        {
          t: 'Soporte o patas', ready: !!S.paellero, lock: 'Elige primero tu paellero', val: val(S.soporte), opt: 'Recomendado',
          body: () => `${this.help('¿Cuál elijo?', '<p><b>Plegable y regulable (el más vendido):</b> soporta hasta 30 kg. Permite nivelar la paella perfectamente en cualquier terreno y se monta de forma instantánea.</p><p><b>Patas:</b> ideales para cocinar paellas pequeñas de manera ocasional. Diseño compacto que soporta hasta 15 kg.</p><p><b>Soporte reforzado profesional:</b> diseñado para paellas gigantes de entre 40 y 50 raciones. Máxima estabilidad, soporta hasta 60 kg.</p>')}
            ${this.grid(soportesFor(C, S.paellero), { current: S.soporte })}
            <div class="lotes-row lotes-row--end"><button type="button" class="lotes-link" data-act="skip" data-v="soporte">Ya tengo soporte</button></div>`,
        },
        {
          t: 'Regulador y goma', ready: !!S.paellero, lock: 'Necesario para conectar la bombona', val: val(S.regulador), opt: 'Recomendado',
          body: () => `${this.help('¿30 o 50 mbar?', '<p>La única diferencia es la <b>presión máxima de gas</b> que dejan pasar al quemador. El de 30 mbar es el doméstico estándar y es suficiente para paelleros tradicionales de hasta 2 aros (50 cm), 3 aros (45 cm) o modelos planos de hasta 30 cm. Para tamaños superiores, es necesario el de 50 mbar para que el fuego no se quede corto.</p>')}
            ${this.grid(reguladoresFor(C, S.paellero), { current: S.regulador })}
            <div class="lotes-row lotes-row--end"><button type="button" class="lotes-link" data-act="skip" data-v="regulador">Ya tengo regulador</button></div>`,
        },
        {
          t: 'Paravientos', opt: 'Opcional', ready: S.paellas.length > 0 || !!S.paellero, lock: 'Para paella o para paellero', val: extraNames(['paravientos']),
          body: () => {
            const l = paravientosFor(C, S.paellero, S.paellas);
            return `${this.help('¿Para paella o para paellero?', '<p><b>Para paella:</b> se cuelga directamente sobre el borde metálico de la paella. Idóneo para paellas grandes, pero hay que ponerlo y quitarlo en cada uso.</p><p><b>Para paellero:</b> rodea los aros de llama y los protege directamente del viento. Puede guardarse acoplado al quemador sin desmontar.</p>')}
              ${l.length ? this.grid(l, { multi: true }) : '<div class="lotes-empty">No hay paravientos para esta combinación.</div>'}`;
          },
        },
        {
          t: 'Asador, plancha o sartén honda', opt: 'Opcional', ready: !!S.paellero, lock: 'Saca más partido a tu paellero', val: extraNames(['asador', 'sarten']),
          body: () => {
            const a = asadoresFor(C, S.paellero), s = sartenesFor(C, S.paellero);
            return `${this.help('Detalles', '<p><b>Asadores de 42 y 52 cm:</b> hierro fundido de alta resistencia, asas de muelle metálico. Reversibles: cara lisa y ondulada.</p><p><b>Asador de 65 cm:</b> nuestro modelo más grande, íntegramente en hierro fundido. Reversible.</p><p><b>Plancha de 46 cm:</b> acero esmaltado, ligera y sin mantenimiento contra el óxido. Reversible.</p><p><b>Sartén honda:</b> perfecta para guisos, arroces caldosos, migas, frituras o fideuás.</p>')}
              <h4 class="lotes-sub">Asador o plancha</h4>${a.length ? this.grid(a, { multi: true }) : '<div class="lotes-empty">No hay asadores para este paellero.</div>'}
              <h4 class="lotes-sub">Sartén honda</h4>${s.length ? this.grid(s, { multi: true }) : '<div class="lotes-empty">No hay sartenes para este paellero.</div>'}`;
          },
        },
      ];
      this.steps.innerHTML = steps.map((s, i) => {
        const open = S.open === i && s.ready, done = !!s.val && !open;
        return `<section class="lotes-step${open ? ' is-open' : ''}${done ? ' is-done' : ''}${!s.ready ? ' is-locked' : ''}">
          <button type="button" class="lotes-step__head" data-toggle="${i}" ${!s.ready ? 'disabled' : ''} aria-expanded="${open}">
            <span class="lotes-step__num">${done ? '✓' : i + 1}</span>
            <span class="lotes-step__text"><span class="lotes-step__title">${s.t}${s.opt ? `<span class="lotes-tag">${s.opt}</span>` : ''}</span><span class="lotes-step__val">${s.val || (s.ready ? (s.opt ? 'Puedes saltar este paso' : 'Pendiente') : s.lock)}</span></span>
            ${done ? '<span class="lotes-link">Cambiar</span>' : ''}
          </button>${open ? `<div class="lotes-step__body">${s.body()}</div>` : ''}</section>`;
      }).join('');
      this.renderSummary();
    }
    renderSummary() {
      const S = this.S, it = this.items(), t = total(it), ok = this.canAdd();
      const req = [S.paellas[0] || (S.noPaella ? { skipped: 'Sin paella' } : null), S.paellero, S.soporte, S.regulador];
      const missing = [];
      if (!S.paellas.length && !this.hasSarten()) missing.push(S.noPaella ? 'una sartén honda' : 'la paella');
      if (!S.paellero) missing.push('el paellero');
      this.summary.innerHTML = `<div class="lotes-sum__head"><h3>Tu lote</h3><span class="lotes-muted">${it.length} pieza${it.length === 1 ? '' : 's'}</span></div>
        <div class="lotes-sum__list">
          ${it.map((x) => `<div class="lotes-sum__li"><img src="${x.thumb}" alt="" width="44" height="44"><a href="${x.url}" target="_blank">${esc(x.name)}</a><b>${money(x.price)}</b></div>`).join('')}
          ${req.map((x, i) => (x ? '' : `<div class="lotes-sum__li is-empty"><span></span><span>${STEP_NAMES[i]}${i > 1 ? ' (recomendado)' : ''}</span></div>`)).join('')}
        </div>
        ${this.threshold ? `<div class="lotes-sum__ship"><div>${shippingHTML(t, this.threshold)}</div><div class="lotes-bar"><i style="width:${Math.min(100, (t / (this.threshold * 100)) * 100)}%"></i></div></div>` : ''}
        <div class="lotes-sum__total"><span class="lotes-muted">Total</span><b>${money(t)}</b></div>
        <button type="button" class="lotes-btn lotes-btn--full" data-act="add" ${ok ? '' : 'disabled'}>Añadir lote al carrito</button>
        <p class="lotes-sum__note" data-note>${ok ? '' : 'Falta: ' + missing.join(' y ')}</p>`;
    }
    async onClick(e) {
      const S = this.S, C = this.C;
      const a = e.target.closest('[data-act]');
      if (a && this.contains(a)) {
        const act = a.dataset.act, v = a.dataset.v;
        if (act === 'add') {
          const ok = await addToCart(this.items(), a);
          if (!ok) this.querySelector('[data-note]').textContent = 'Problema al procesar el lote. Inténtalo de nuevo.';
          return;
        }
        if (act === 'finish') S.finish = v;
        if (act === 'gama') { S.gama = v; S.paellero = null; }
        if (act === 'all') S.showAll = true;
        if (act === 'continue') this.nextOpen();
        if (act === 'nopaella') { S.noPaella = true; S.paellas = []; this.nextOpen(); }
        if (act === 'skip') { S[v] = null; S.open = v === 'soporte' ? 3 : 4; }
        S.msg = '';
        this.render();
        return;
      }
      const tg = e.target.closest('[data-toggle]');
      if (tg) { const i = +tg.dataset.toggle; S.open = S.open === i ? -1 : i; S.showAll = false; this.render(); return; }
      const card = e.target.closest('.lotes-card');
      if (!card || card.disabled) return;
      const item = C.byId(card.dataset.id);
      S.msg = '';
      if (item.kind === 'paella') {
        const i = S.paellas.indexOf(item);
        if (i > -1) S.paellas.splice(i, 1);
        else if (S.paellas.length >= MAX_PAELLAS) S.msg = `Máximo ${MAX_PAELLAS} tamaños de paella por lote.`;
        else { S.paellas.push(item); S.noPaella = false; }
      } else if (item.kind === 'paellero') { S.paellero = item; this.nextOpen(); }
      else if (item.kind === 'soporte') { S.soporte = item; this.nextOpen(); }
      else if (item.kind === 'regulador') { S.regulador = item; this.nextOpen(); }
      else { const id = String(item.id); S.extras.has(id) ? S.extras.delete(id) : S.extras.add(id); }
      this.render();
    }
  }

  // ---------- ready-made sets by diners -------------------------------------
  const RANGES = [['4 – 6', ['32', '34']], ['7 – 10', ['36', '38', '40', '42']], ['11 – 15', ['46', '50']], ['16 – 25', ['55', '60', '65', '70']], ['26 – 40', ['75', '80']], ['Más de 40', ['85', '90']]];
  class LotesComensales extends HTMLElement {
    connectedCallback() {
      this.C = loadCatalogue();
      this.threshold = Number(this.dataset.freeShipping || 0);
      this.S = { range: 2, finish: 'esmaltada', cm: null, selected: null };
      this.body = this.querySelector('[data-body]');
      this.tabs = this.querySelector('[data-tabs]');
      this.addEventListener('click', (e) => this.onClick(e));
      this.render();
      if (this.tabs) this.setTab(location.hash === '#pieza-a-pieza' ? 'builder' : 'sets');
    }
    // Tabs: "Lotes recomendados" (this section) or "Pieza a pieza" (the lotes-configurador section)
    setTab(tab, scroll = false) {
      if (!this.tabs) return;
      this.tabs.querySelectorAll('[data-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.tab === tab)));
      this.querySelector('[data-panel]').hidden = tab !== 'sets';
      const builder = document.querySelector('lotes-configurador');
      if (builder) builder.toggleAttribute('data-tab-open', tab === 'builder');
      history.replaceState(null, '', tab === 'builder' ? '#pieza-a-pieza' : location.pathname + location.search);
      if (scroll) this.tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    // Four sets for the chosen paella, always within the compatibility rules:
    //  (paelleros never wider than the paella)
    //  Básico      cheapest paellero + patas + regulator (lowest total)
    //  Estándar    mid-priced standard paellero, 30 mbar regulator if it fits, folding adjustable stand
    //  Completo    mid-high standard paellero, same stand/regulator + windbreak, deep pan and grill plate
    //  Profesional mid-high FLAT paellero, same stand/regulator + windbreak, deep pan and grill
    bundles(paella) {
      const C = this.C, ps = [paella];
      const avail = (l) => l.filter((x) => x.available);
      const byPrice = (l) => avail(l).slice().sort((a, b) => a.price - b.price);
      const tier = (l, q) => { const s = byPrice(l); return s.length ? s[Math.round(q * (s.length - 1))] : null; };
      const prefer = (l, key) => avail(l).find((x) => x.key === key) || byPrice(l)[0] || null;
      const closest = (l, cm) => avail(l).sort((a, b) => Math.abs(a.cm - cm) - Math.abs(b.cm - cm) || a.price - b.price)[0] || null;
      // Burners wider than the paella are allowed by the rules but make no sense in a ready-made set
      const all = C.paelleros.filter((p) => p.available && paelleroFits(p, ps));
      const notWider = all.filter((p) => +p.cm <= +paella.cm);
      const fits = notWider.length ? notWider : all;
      const std = fits.filter((p) => !isPlano(p)), pl = fits.filter(isPlano);
      const cheapest = fits
        .map((pe) => ({ pe, so: prefer(soportesFor(C, pe), 'patas-paellero'), rg: byPrice(reguladoresFor(C, pe))[0] }))
        .sort((x, y) => (x.pe.price + (x.so ? x.so.price : 0) + (x.rg ? x.rg.price : 0)) - (y.pe.price + (y.so ? y.so.price : 0) + (y.rg ? y.rg.price : 0)))[0];
      const make = (name, sub, pe, extra, best) => {
        if (!pe) return null;
        const items = [paella, pe, prefer(soportesFor(C, pe), 'soporte-regulable'), prefer(reguladoresFor(C, pe), 'regulador-30-goma')];
        if (extra) {
          const pv = avail(paravientosFor(C, pe, ps));
          items.push(pv.find((x) => x.key !== 'paella') || pv[0]);
          items.push(closest(sartenesFor(C, pe), +paella.cm));
          const grills = avail(asadoresFor(C, pe));
          items.push(extra === 'plancha' ? grills.find((x) => x.key === 'plancha-46') : byPrice(grills.filter((x) => x.key !== 'plancha-46')).pop());
        }
        return { name, sub, items: items.filter(Boolean), best };
      };
      return [
        cheapest ? { name: 'Lote Básico', sub: 'Lo más económico para empezar', items: [paella, cheapest.pe, cheapest.so, cheapest.rg].filter(Boolean) } : null,
        make('Lote Estándar', 'Paellero de gama media y soporte plegable y regulable', tier(std.length ? std : fits, 0.5), null),
        make('Lote Completo', 'El estándar + paravientos, sartén honda y plancha grill', tier(std.length ? std : fits, 0.75), 'plancha', true),
        make('Lote Profesional', 'Paellero plano + paravientos, sartén honda y asador', tier(pl, 0.75), 'asador'),
      ].filter(Boolean);
    }
    render() {
      const S = this.S, C = this.C;
      const sizes = RANGES[S.range][1];
      const avail = C.paellas[S.finish].filter((p) => sizes.includes(p.cm) && p.available);
      if (!avail.find((p) => p.cm === S.cm)) S.cm = avail[0] ? avail[0].cm : null;
      const paella = avail.find((p) => p.cm === S.cm);
      this.current = paella ? this.bundles(paella) : [];
      this.body.innerHTML = `
        <div class="lotes-chips" role="group" aria-label="Comensales">${RANGES.map(([l, s], i) => `<button type="button" class="lotes-chip${i === S.range ? ' is-on' : ''}" data-range="${i}" aria-pressed="${i === S.range}">${l}<small>${s[0]}${s.length > 1 ? '–' + s[s.length - 1] : ''} cm</small></button>`).join('')}</div>
        <div class="lotes-row lotes-row--wide">
          <div><div class="lotes-label">Tamaño exacto</div>${avail.length ? `<span class="lotes-seg">${avail.map((p) => `<button type="button" data-cm="${p.cm}" class="${p.cm === S.cm ? 'is-on' : ''}">${p.cm} cm · ${p.raciones} raciones</button>`).join('')}</span>` : '<span class="lotes-muted">—</span>'}</div>
          <div><div class="lotes-label">Acabado de la paella</div><span class="lotes-seg"><button type="button" data-finish="esmaltada" class="${S.finish === 'esmaltada' ? 'is-on' : ''}">Esmaltada · sin mantenimiento</button><button type="button" data-finish="pulida" class="${S.finish === 'pulida' ? 'is-on' : ''}">Pulida · tradicional</button></span></div>
        </div>
        ${paella ? `<div class="lotes-packs">${this.current.map((b, i) => this.packHTML(b, i)).join('')}</div>` : `<div class="lotes-empty">${S.finish === 'pulida' ? 'La paella pulida empieza en 50 cm. Elige más comensales o la esmaltada.' : 'No hay paellas disponibles en este tamaño ahora mismo.'}</div>`}
        <p class="lotes-alt">¿Ya tienes alguna pieza o prefieres elegirlo todo tú? <button type="button" class="lotes-link" data-custom="-1">Montar mi lote pieza a pieza →</button></p>`;
    }
    // The recommended set is selected until the shopper clicks another one
    selectedIndex() {
      if (this.S.selected !== null && this.current[this.S.selected]) return this.S.selected;
      const best = this.current.findIndex((b) => b.best);
      return best > -1 ? best : 0;
    }
    packHTML(b, i) {
      const t = total(b.items);
      return `<div class="lotes-pack${i === this.selectedIndex() ? ' is-selected' : ''}" data-pack="${i}">${b.best ? '<span class="lotes-badge lotes-pack__badge">Recomendado</span>' : ''}
        <div><h3>${b.name}</h3><p class="lotes-muted">${b.sub}</p></div>
        <ul>${b.items.map((x) => `<li><img src="${x.thumb}" alt="" width="44" height="44"><span>${esc(x.name)}</span><b>${money(x.price)}</b></li>`).join('')}</ul>
        <div class="lotes-pack__total"><span class="lotes-muted">Total</span><b>${money(t)}</b></div>
        ${this.threshold ? `<div class="lotes-pack__ship">${shippingHTML(t, this.threshold)}</div>` : ''}
        <button type="button" class="lotes-btn lotes-btn--full${i === this.selectedIndex() ? '' : ' lotes-btn--ghost'}" data-add="${i}">Añadir lote al carrito</button>
        <button type="button" class="lotes-link" data-custom="${i}">Personalizar este lote</button>
        <p class="lotes-sum__note" data-note="${i}"></p></div>`;
    }
    async onClick(e) {
      const S = this.S;
      const tab = e.target.closest('[data-tab]');
      if (tab) { this.setTab(tab.dataset.tab); return; }
      const r = e.target.closest('[data-range]'); if (r) { S.range = +r.dataset.range; S.cm = null; S.selected = null; this.render(); return; }
      const c = e.target.closest('[data-cm]'); if (c) { S.cm = c.dataset.cm; S.selected = null; this.render(); return; }
      const f = e.target.closest('[data-finish]'); if (f) { S.finish = f.dataset.finish; S.selected = null; this.render(); return; }
      // Clicking anywhere on a set selects it (the navy outline follows the last set clicked)
      const pack = e.target.closest('[data-pack]');
      if (pack && +pack.dataset.pack !== this.selectedIndex()) {
        S.selected = +pack.dataset.pack;
        this.render();
      }
      const a = e.target.closest('[data-add]');
      if (a) {
        const ok = await addToCart(this.current[+a.dataset.add].items, a);
        if (!ok) this.querySelector(`[data-note="${a.dataset.add}"]`).textContent = 'Problema al procesar el lote. Inténtalo de nuevo.';
        return;
      }
      const cu = e.target.closest('[data-custom]');
      if (cu) {
        const builder = document.querySelector('lotes-configurador');
        if (!builder) return;
        const i = +cu.dataset.custom;
        if (i > -1) {
          const it = this.current[i].items;
          const k = (kind) => (it.find((x) => x.kind === kind) || {}).id;
          builder.load({ finish: S.finish, paellas: [k('paella')], paellero: k('paellero'), soporte: k('soporte'), regulador: k('regulador'), extras: it.filter((x) => ['paravientos', 'asador', 'sarten'].includes(x.kind)).map((x) => x.id) });
        } else {
          const sizes = RANGES[S.range][1];
          const p = this.C.paellas[S.finish].find((x) => x.cm === S.cm && sizes.includes(x.cm));
          builder.load({ finish: S.finish, paellas: p ? [p.id] : [] });
        }
        if (this.tabs) this.setTab('builder', true);
        else builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  window.LotesJesa = { loadCatalogue, paelleroFits, soportesFor, reguladoresFor, paravientosFor, asadoresFor, sartenesFor };
  customElements.define('lotes-configurador', LotesConfigurador);
  customElements.define('lotes-comensales', LotesComensales);
})();
